import { axiosInstance } from '../axiosConfig.ts';
import { handleRequestWithAuth } from '../refreshService.ts';
import { Cliente } from '../citasService.ts';

export type DatosClientePOS = {
  first_name: string; last_name: string; email: string; password: string;
  ci_nit: string; telefono: string; codigo_tipo_documento_identidad_sin: number;
  complemento: string; punto_de_venta: number;
};
export const documentosClientePOS = (pos: number) => handleRequestWithAuth(async()=>
  (await axiosInstance.get<{codigo:string;descripcion:string}[]>('clientes/documentos-pos/',{params:{punto_de_venta:pos}})).data);
export const guardarClientePOS = (data: DatosClientePOS, id?: number) => handleRequestWithAuth(async()=>
  (id ? await axiosInstance.put<Cliente>(`clientes/${id}/editar-pos/`,data) : await axiosInstance.post<Cliente>('clientes/crear-pos/',data)).data);
